import { Card, Switch } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { MobiLinkAnimalDto } from "../../generated/tsClient";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setSelectedAnimal, setShowBarcodeScannerModal } from "../../store/slices/appSlice";
import IcomoonReact from "icomoon-react";
import iconSet from "../../icons/selection.json";

function Animal(props: any) {
    const { t } = useTranslation('texts');
    const dispatch = useAppDispatch();
    const canOrderPregCheck = useAppSelector((state) => state.app.herdCanOrderPregCheck);
    const insemDaysHighlightLimits = useAppSelector((state) => state.app.insemDaysHighlightLimits);
    const animal: MobiLinkAnimalDto = props.animal;
    const handleBarcodeChange = props.handleBarcodeChange;
    const handlePregCheckOrderChange = props.handlePregCheckOrderChange;

    const handleClick = () => {
        if (animal.barcode == null) {
            dispatch(setSelectedAnimal(animal.euIdentifier));
            dispatch(setShowBarcodeScannerModal(true));
        }
    };

    const hasHighlight = (days: number) => {
        if (insemDaysHighlightLimits != null && insemDaysHighlightLimits.value2 != null && insemDaysHighlightLimits.value3 != null && insemDaysHighlightLimits.value4 != null &&
          ((days >= insemDaysHighlightLimits.value1 && days <= insemDaysHighlightLimits.value2) || (days >= insemDaysHighlightLimits.value3 && days <= insemDaysHighlightLimits.value4)))
            return true;
        return false;
    };

    return (
        <Card className={"animal " + (animal.barcode != null ? "has_barcode" : "no-barcode")} onClick={handleClick }>
            <Row>
                <Col xs="5" className="earnr-name">{animal.earNr} {animal.nameShort}</Col>
                <Col>{animal.euIdentifier + '-' + animal.euCheck}</Col>
            </Row>
            {animal.barcode != null && (
                <Row>
                    <Col className="barcode" xs="5">
                        <IcomoonReact iconSet={iconSet} icon="barcode" size={20} /> {animal.barcode}
                        <CloseOutlinedIcon className="red" onClick={() => handleBarcodeChange(animal.euIdentifier, undefined)} />
                    </Col>
                    <Col>
                        {canOrderPregCheck && (
                            <span>
                            {t("List.FertilityTest")}
                            <Switch
                                checked={animal.pregCheckOrder}
                                onChange={(e) => { handlePregCheckOrderChange(animal.euIdentifier) }}
                                ></Switch>
                            </span>
                        )}
                    </Col>
                </Row>
            )}
            {animal.barcode != null && (
                <Row>
                    <Col xs="5">{animal.lastPregCheckDate != null ? new Date(animal.lastPregCheckDate).toLocaleDateString('fi-FI', { year: 'numeric', month: '2-digit', day: '2-digit' }) + (animal.lastPregnancyCode === 1 ? " +" : " -") : ''}</Col>
                    {animal.daysFromInsem != null && (
                        <Col>{t("List.InseminationDays")} <span className={hasHighlight(animal.daysFromInsem) ? 'highlight' : ''} >{animal.daysFromInsem}</span></Col>
                    )}
                    {animal.daysFromInsem == null && (
                        <Col></Col>
                    )}
                </Row>
            )}
        </Card>
    );
}

export default Animal;